<template>
    <div class="pb-3">
        <component :is="isLink ? 'a' : 'div'" :href="isLink ? link : null"
            @click="isLink ? registerClick() : null" target="_blank">
            <h4 class="primary--text d-inline">{{ title }}</h4>
            <div class="d-inline" v-if="isLink">
                <tag color="blue lighten-4" label="CDP" tooltip="Code Development Proposal" />
                <tag color="green lighten-4" label="ES" tooltip="Evaluation Service" />
            </div>
        </component>
    </div>
</template>

<script>
import Tag from './Tag.vue';
export default {
    data: function() {
        return {

        }
    },
    components: {Tag},
    props: {
        title: {
            type: String,
            required: true
        },
        contentId: {
            type: Number,
            required: true
        },
        isLink: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        link() {
            return Routing.generate('content_id_redirect', {
                'contentId': this.contentId
            });
        }
    },
    methods:{
        registerClick(){
            console.log('Log details');
        }
    }
}
</script>

<style scoped lang="scss">

</style>